__turbopack_context__.v({
  "className": "baloobhaifont_43d47b88-module__Ienw5q__className",
  "variable": "baloobhaifont_43d47b88-module__Ienw5q__variable",
});
